import(/* webpackMode: "eager", webpackExports: ["WorkflowBreadcrumbs"] */ "/app/app/(keep)/workflows/[workflow_id]/workflow-breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(keep)/workflows/[workflow_id]/workflow-detail-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["signOut"] */ "/app/node_modules/next-auth/react.js");
